import React from 'react';
import { useNavigate } from 'react-router-dom';
import KodaSad from '../components/Custom Icons/Koda_Sad.js';
import AppButton from '../components/AppButton';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6 text-center gap-6">
      <div className="w-40">
        <KodaSad style={{ width: '100%', height: 'auto' }} />
      </div>
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-bold text-text-primary">Ruh Roh!</h1>
        <p className="text-text-secondary text-sm max-w-xs">
          I couldn't find that page. It may have been moved or maybe it never existed, the plot thickens... let's return home where all the good things are.
        </p>
      </div>
      <AppButton onClick={() => navigate('/')} variant="primary" className="!w-auto px-6 py-3 !shadow-none">
        Return Home
      </AppButton>
    </div>
  );
}
